<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/guys.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              Contact
            </h1>
            <div class="intro">We truly are here to help.  Whether you have web3 questions, need help on a project, or just need someone to talk to, you can reach out to us any time!</div>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <p>You can contact us anytime via our email at <a href="mailto:nfdaddys@gmail.com">NFDaddys@gmail.com</a></p>
      <p>We're also always available in our <a href="https://discord.gg/4gQZYE9NC9" target="_blank">Discord</a>, come join the fun!</p>
      <p>You can also reach us via our Twitter accounts below:</p>
      <ul style="list-style: disc; margin-left: 40px;">
        <li><a href="https://twitter.com/nfdaddys" target="_blank">NFDaddys</a></li>
        <li><a href="https://twitter.com/TheStarsPodcast" target="_blank">Ron</a></li>
        <li><a href="https://twitter.com/awo211" target="_blank">David</a></li>
        <li><a href="https://twitter.com/GeraintTaylor" target="_blank">Geraint</a></li>
        <li><a href="https://twitter.com/markeetox" target="_blank">Marcos</a></li>
        <li><a href="https://twitter.com/uncleirohlovesu" target="_blank">Stephen</a></li>
      </ul>
    </section>
	</div>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "Contact",
  methods: {

  },
};
/* eslint-enable no-console */
</script>
<style scoped>


</style>